import React, { useState } from "react";

import useCustomerReviewApproveReject from "../../hooks/useCustomerReviewApproveReject";
import useFormatMessage from "../../hooks/useFormatMessage";
import useSnackbar from "../../hooks/useSnackbar";
import { CustomerDetails } from "../../types/utilities";
import Confirm from "../Confirm/Confirm";
import KDKTextField from "../KDKTextField/KDKTextField";

type CustomerReviewApproveConfirmProps = {
  customer: CustomerDetails;
  reviewId: string;
  onSuccess(): void;
  onCancel(): void;
};

const CustomerReviewApproveConfirm = (props: CustomerReviewApproveConfirmProps) => {
  const { customer, reviewId, onSuccess, onCancel } = props;

  const f = useFormatMessage();
  const { setSnackbar } = useSnackbar();

  const [reason, setReason] = useState("");
  const { approveReviewMutation } = useCustomerReviewApproveReject(customer, reviewId);

  const handleReviewApprove = () => {
    setReason("");
    onSuccess();
    setSnackbar(f("common.labels.approved"));
  };

  return (
    <Confirm
      isOpen
      title={f("details.reviews.confirm.approve-reject.title")}
      onYes={() => approveReviewMutation.mutate(reason, { onSuccess: handleReviewApprove })}
      onNo={onCancel}
      isDestructive={false}
      actionTitle={f("details.reviews.confirm.approve")}
      cancelTitle={f("default.cancel")}
      isActionInProgress={approveReviewMutation.isLoading}
      error={approveReviewMutation.error}
    >
      <KDKTextField
        label={f("details.reviews.confirm.approve-reject.title")}
        labelHidden
        value={reason}
        multiline={6}
        autoFocus
        autoComplete="on"
        disabled={approveReviewMutation.isLoading}
        onChange={setReason}
      />
    </Confirm>
  );
};

export default CustomerReviewApproveConfirm;
